import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Home from "./Home";
import AdminDashboard from "./components/admin/AdminDashboard";
import Login from "./components/admin/Login";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import LeadPathPortal from "./components/LeadPathPortal";
import { useAttribution } from "./components/AttributionProvider";
import TrafficTracker from "./components/utils/TrafficTracker";
import CampaignCaptureForm from "./components/CampaignCaptureForm";
import "./index.css";

function AppRoutes() {
  useAttribution();
  return (
    <>
      <TrafficTracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/apply" element={new URLSearchParams(window.location.search).has("lp_campaign")
          ? <CampaignCaptureForm brand="My Income Harbor" eyebrow="Retirement income request" heading="Begin with a secure retirement-income contact request." intro="Your contact is delivered immediately. A short optional discovery can then organize income, liquidity, timing, and priorities." tracker={(name,details)=>window.mihEvents?.track?.(name,details)} />
          : <Home />} />
        <Route path="/client-portal" element={<LeadPathPortal />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default function App() {
  return <BrowserRouter><AppRoutes /></BrowserRouter>;
}
